import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../../../base/FormButton';
import OptionsInput from '../../../base/OptionsInput';
import InputsField from '../../../base/InputsField';
import Styles from '../CommentsForm.styles';

const FieldGroup = styled.div`${Styles.fieldGroup}`; // prettier-ignore

/**
 * Create the form component
 * @param  {any} props componente properties
 * @returns {JSX}
 */
const Form = (props) => {
  const {
    data,
    translations,
    handleChange,
    areaHandler,
    handleSubmit,
    disableButton
  } = props;
  const {
    name,
    surnames,
    postalcode,
    email,
    subject,
    comment,
    subjectOptions
  } = data;

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-5 ">
          <InputsField
            placeHolder={`${translations.name}`}
            label={`${translations.name}`}
            value={name.value}
            onChange={e => handleChange(e)}
            name="name"
            status={name.status}
            isRequired
          />
        </div>
        <div className="col-xs-12 col-sm-6 offset-md-1">
          <InputsField
            placeHolder={`${translations.surnames}`}
            label={translations.surnames}
            value={surnames.value}
            name="surnames"
            status={surnames.status}
            isRequired
            onChange={e => handleChange(e)}
          />
        </div>
        <div className="col-xs-12 col-sm-5">
          <InputsField
            placeHolder={`${translations.postalcode}`}
            label={translations.postalcode}
            value={postalcode.value}
            name="postalcode"
            status={postalcode.status}
            onChange={e => handleChange(e)}
          />
        </div>
        <div className="col-xs-12 col-sm-6 offset-md-1">
          <InputsField
            placeHolder={`${translations.email}`}
            label={translations.email}
            value={email.value}
            name="email"
            status={email.status}
            onChange={e => handleChange(e)}
          />
        </div>
        <div className="col-xs-12 col-sm-5">
          <OptionsInput
            onChange={e => areaHandler(e)}
            options={subjectOptions}
            value={subject.value}
            name={translations.subject}
            hasBlackTheme
          />
        </div>
        <div className="col-xs-12 col-sm-12">
          <InputsField
            placeHolder={`${translations.question}`}
            label={translations.question_label}
            value={comment.value}
            name="comment"
            status={comment.status}
            onChange={e => handleChange(e)}
          />
          <FieldGroup>
            <Button
              className="cbx-regular"
              disableButton={disableButton}
              label={translations.send}
              buttonAction={() => handleSubmit()}
            />
          </FieldGroup>
        </div>
      </div>
    </div>
  );
};
Form.propTypes = {
  data: PropTypes.object,
  translations: PropTypes.object,
  handleChange: PropTypes.func,
  areaHandler: PropTypes.func,
  handleSubmit: PropTypes.func,
  disableButton: PropTypes.bool
};

export default Form;
